export enum ViewStateEnum {
    LOGIN = "LOGIN",
    FORGOT_PASSWORD = "FORGOT_PASSWORD",
    RESET_PASSWORD = "RESET_PASSWORD",
    FIRST_ACCESS = "FIRST_ACCESS",
}
